module.exports = __webpack_public_path__ + "static/pic01-b9959e167f94349be29be7284e7b9112.jpg";